export const FeatureType = {
	Storage: 'storage',
	Time: 'time',
	Count: 'count',
	String: 'string',
	Boolean: 'boolean',
} as const;
export type FeatureType = (typeof FeatureType)[keyof typeof FeatureType];

export const FeaturePeriod = {
	Daily: 'DAILY',
	Weekly: 'WEEKLY',
	Monthly: 'MONTHLY',
	Yearly: 'YEARLY',
	Lifetime: 'LIFETIME',
} as const;
export type FeaturePeriod = (typeof FeaturePeriod)[keyof typeof FeaturePeriod];

export const StorageUnit = {
	B: 'B',
	KB: 'KB',
	MB: 'MB',
	GB: 'GB',
	TB: 'TB',
} as const;
export type StorageUnit = (typeof StorageUnit)[keyof typeof StorageUnit];

export const TimeUnit = {
	Second: 'second',
	Seconds: 'seconds',
	Minute: 'minute',
	Minutes: 'minutes',
	Hour: 'hour',
	Hours: 'hours',
	Day: 'day',
	Days: 'days',
} as const;
export type TimeUnit = (typeof TimeUnit)[keyof typeof TimeUnit];

export const VideoCodec = {
	H264: 'h264',
	H265: 'h265',
} as const;
export type VideoCodec = (typeof VideoCodec)[keyof typeof VideoCodec];

export const Resolution = {
	P360: '360p',
	P480: '480p',
	P720: '720p',
	P1080: '1080p',
	P1440: '1440p',
	P2160: '2160p',
} as const;
export type Resolution = (typeof Resolution)[keyof typeof Resolution];

export const FeatureKey = {
	VideoUploads: 'video_uploads',
	MaxEncodesPerVideo: 'max_encodes_per_video',
	MaxVideoDuration: 'max_video_duration',
	StorageSpace: 'storage_space',
	VideoCodecs: 'video_codecs',
	MaxVideoResolution: 'max_video_resolution',
	EncodingMinutes: 'encoding_minutes',
	HdrSupport: 'hdr_support',
} as const;
export type FeatureKey = (typeof FeatureKey)[keyof typeof FeatureKey];
